import React, { useMemo } from 'react';
import TableCommonHook from '@op/components/TableCommonHook';
import { useIntl } from 'umi';
import { DBO_V } from '@op/utils/format';
import './index.scss';
import { formatDateFunc } from '@op/utils/time';
import { channelInfo } from '@op/components/ChannelLabel';
import CardCommon from '@op/components/CardCommon';

const CommonTable = (props: {
  filter: any;
  title: string;
  records: Array<any>;
  maxHeight?: number;
  minWidth?: number;
  isEmpty: boolean;
  height?: number;
  isSingle?: boolean;
}) => {
  const {
    isEmpty,
    height,
    filter,
    title,
    records = [],
    maxHeight = 230,
    isSingle,
  } = props;
  const { formatMessage } = useIntl();

  const tableColumns = useMemo(() => {
    const formatTimeFun = formatDateFunc(filter.date_type);
    let columns: any = [
      {
        key: 'time',
        header: formatMessage({ id: 'Date' }),
        align: 'left',
        width: 150,
        render: (cvm: any) => formatTimeFun(cvm.time),
      },
      {
        key: 'key',
        header: formatMessage({ id: 'Channel' }),
        align: 'left',
        width: 130,
        render: (cvm: any) => {
          const { name, img } = channelInfo(cvm.key);
          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={img} style={{ marginRight: 5 }} />
              {name}
            </div>
          );
        },
      },
      {
        key: 'value',
        header: formatMessage({ id: title }),
        render: (cvm: any) => DBO_V.reviews(cvm.value),
        align: 'right',
        width: 130,
      },
    ];

    if (isSingle) {
      columns = columns.filter((item: any) => item.key !== 'key');
    }

    return columns;
  }, [formatMessage, isSingle]);

  return (
    <CardCommon contentCard empty={isEmpty} emptyHeight={height}>
      <TableCommonHook
        recordKey={'key'}
        columns={tableColumns}
        total={records?.length}
        records={records}
        hasPageable={false}
        maxHeight={maxHeight}
        minWidth={'auto'}
      />
    </CardCommon>
  );
};

export default CommonTable;
